export interface Source {
  label: string
  url: string
  publisher?: string
}

// Numbered references list at the foot of the article body. External links only
// (schema validates http/https), so every anchor is target=_blank + noopener.
export function ArticleSources({
  sources,
  title,
}: {
  sources?: Source[]
  title: string
}) {
  if (!sources?.length) return null
  return (
    <section className="mt-10 border-t border-border pt-8">
      <h2 className="font-serif text-xl font-bold text-primary">{title}</h2>
      <ol className="mt-4 space-y-3 text-sm">
        {sources.map((source, i) => (
          <li key={i} className="flex gap-2 text-muted-foreground">
            <span aria-hidden className="shrink-0 text-primary">
              {i + 1}.
            </span>
            <span>
              <a
                href={source.url}
                target="_blank"
                rel="noopener noreferrer"
                className="font-medium text-primary no-underline hover:underline underline-offset-2"
              >
                {source.label}
              </a>
              {source.publisher && <span> — {source.publisher}</span>}
            </span>
          </li>
        ))}
      </ol>
    </section>
  )
}
